var Contribute = React.createClass({
	mixins: [React.addons.PureRenderMixin],

	render: function() {
		return (
			<div>
				<h1>Contribute</h1>
				<hr />
				.
				<br />
				<br />
				<ul>
					<li>.</li>
				</ul>
				<SeeAlso />
			</div>
		)
	},
})
